import * as trackingAnalyticsService from './trackingAnalyticsService';

export default {
  ...trackingAnalyticsService,
};
